'use strict';

var GridSaveSpecialEventButtonController = function GridSaveSpecialEventButtonController($scope) {
  $scope.saveSpecialEvent = function () {
    $scope.$emit('pooled-seasonality:save-events-and-overrides', true);
  };
  $scope.$on('pooled-seasonality-special-events:showSpecialEvents', function (event, isSaveSpecialEventShow) {
    $scope.isSaveSpecialEventShow = isSaveSpecialEventShow;
  });
};
GridSaveSpecialEventButtonController.$inject = ['$scope'];
module.exports = GridSaveSpecialEventButtonController;